export const CookerIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="48"
    height="56"
    viewBox="0 0 48 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.88867 52.2229H11.6394V53.6864C11.6394 54.1915 11.2308 54.6001 10.7257 54.6001H7.80242C7.29726 54.6001 6.88867 54.1915 6.88867 53.6864V52.2229Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.3364 52.2229H41.0871V53.6864C41.0871 54.1915 40.6786 54.6001 40.1734 54.6001H37.2502C36.745 54.6001 36.3364 54.1915 36.3364 53.6864V52.2229Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.4377 21.5085H8.53388C7.96153 21.5085 7.49756 21.9725 7.49756 22.5449V42.8404C7.49756 43.4127 7.96153 43.8767 8.53388 43.8767H39.4377C40.0101 43.8767 40.474 43.4127 40.474 42.8404V22.5449C40.474 21.9725 40.0101 21.5085 39.4377 21.5085Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.37575 10.2464C7.68865 10.2464 8.75297 9.18206 8.75297 7.86916C8.75297 6.55626 7.68865 5.49194 6.37575 5.49194C5.06285 5.49194 3.99854 6.55626 3.99854 7.86916C3.99854 9.18206 5.06285 10.2464 6.37575 10.2464Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7385 10.2464C14.0514 10.2464 15.1158 9.18206 15.1158 7.86916C15.1158 6.55626 14.0514 5.49194 12.7385 5.49194C11.4256 5.49194 10.3613 6.55626 10.3613 7.86916C10.3613 9.18206 11.4256 10.2464 12.7385 10.2464Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1013 10.2464C20.4142 10.2464 21.4786 9.18206 21.4786 7.86916C21.4786 6.55626 20.4142 5.49194 19.1013 5.49194C17.7884 5.49194 16.7241 6.55626 16.7241 7.86916C16.7241 9.18206 17.7884 10.2464 19.1013 10.2464Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.1857 5.49585H26.6566C26.2217 5.49585 25.8691 5.8484 25.8691 6.2833V9.45912C25.8691 9.89402 26.2217 10.2466 26.6566 10.2466H43.1857C43.6206 10.2466 43.9731 9.89402 43.9731 9.45912V6.2833C43.9731 5.8484 43.6206 5.49585 43.1857 5.49585Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.1544 0.600098H2.82503C1.59623 0.600098 0.600098 1.59623 0.600098 2.82503V50.0017C0.600098 51.2305 1.59623 52.2266 2.82503 52.2266H45.1544C46.3832 52.2266 47.3793 51.2305 47.3793 50.0017V2.82503C47.3793 1.59623 46.3832 0.600098 45.1544 0.600098Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.600098 46.9521H47.3756"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.600098 14.7373L47.3756 14.2024"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.01562 18.4478H41.9599"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
